<template>
  <div class="input-group input-group-search">
    <input type="text" class="form-control" @keyup.enter="performSearch" :placeholder='$t("navigation.search")'
           v-model="searchTerm"/>
    <div class="input-group-append" @click="performSearch">
      <span class="input-group-text"><FindIcon/></span>
    </div>
  </div>
</template>

<script>
import FindIcon from "@/components/icons/FindIcon";
import { ref } from "@vue/composition-api";

export default {
  name: "QuicksearchComponent",
  components: { FindIcon },

  setup(props, context) {
    const searchTerm = ref("");

    function performSearch() {
      context.emit('performSearch', searchTerm.value)
    }

    return {
      searchTerm,
      performSearch
    }
  }
}
</script>

<style lang="scss">
.input-group-search {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 472px;

  .form-control {
    position: relative;
    flex: 1 1 auto;
    min-width: 0;
    margin-bottom: 0;
    display: block;
    width: 100%;
    height: 48px;
    padding: .65rem .75rem;
    padding-left: 20px;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5;
    color: #8EA2A8;
    background-color: #fff;
    background-clip: padding-box;
    border: 0 solid #ced4da;
    border-radius: 25px;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;

    &::placeholder {
       color: #8EA2A8;
     }

    &:focus {
       outline: none;
     }
    }

    .input-group-text {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      padding: 1rem;
      padding-right: 26px;
      cursor: pointer;

    svg {
      width: 18px;
      height: 18px;

      .a {
        stroke: $primary;
      }
    }
  }
}
</style>
